'use client';

import { useState } from 'react';
import { Button } from '@/app_components/ui/Button';
import { Input } from '@/app_components/ui/input';

export const SearchBar = () => {
  const [value, setValue] = useState('');
  const handleSubmit = (event: React.FormEvent) => {
    event.preventDefault();
    window.location.href = `https://fortune.com/advanced-search/?query=${encodeURIComponent(value)}`;
  };

  return (
    <div className='mb-8 pl-4 pb-6'>
      {/* TODO: Update this once the Form component is ready to be used */}
      {/** biome-ignore lint/nursery/noRestrictedElements: not too sure how to use it yet */}
      <form
        aria-label='search'
        className='flex items-center justify-center h-12'
        method='get'
        onSubmit={handleSubmit}
      >
        <Input
          aria-label='What are you looking for?'
          className='h-full rounded-xs typography-level-5 max-w-[calc(-50px+65vw)] sm:w-[calc(-100px+50vw)] sm:left-[33vw]'
          onChange={(e) => setValue(e.target.value)}
          placeholder='What are you looking for?'
          type='text'
          value={value}
        />
        <Button
          className='h-full p-6'
          type='submit'
          variant='primary'
        >
          <div className='flex items-center'>
            Search
            <span className='icon icon-arrow-right' />
          </div>
        </Button>
      </form>
    </div>
  );
};
